import { Box, Grid, LinearProgress, Paper, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { MaintenanceItemEmpty } from '../Dashboard'
import Select from "react-select";
import Scrollbar from 'react-scrollbars-custom';
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { nFormatter } from '../../../Helpers';
import Button from "../../../Components/common/Button";
import { useDispatch } from 'react-redux';
import { setSaleChildData, setSaleParentData } from '../../../Actions/SaleDashboard';
import { useSelector } from 'react-redux';
import DashboardCardInfo from '../../../Components/common/DashboardCardInfo';


 const usersOption = [
  { label: "Total Sales", value: 66},
  { label: "Region Sales", value: 75 },
  { label: "Account Managers", value: 61},
];

const SalePerformanceTrackerWidgets = (props) => {
  const dispatch = useDispatch();
  const salePerformance = useSelector((state) => state.salePerformance);

  const [newData21, setNewData21] = useState({ data: [], isLoading: false });
  const [newData21b, setNewData21b] = useState({ data: [], isLoading: false });
  const [selectedUser, setSelectedUser] = useState(usersOption[0]);
  const [selectedChildUserId, setSelectedChildUserId] = useState(null);
  const [isSelectedChildUser, setIsSelectedChildUser] = useState(false);

  const handleSelectedUser = (option) => {
    setSelectedUser(option);
  };

  const fetchEXD21Data = async ({ type, paramId, isChild }) => {
    try {
      if (isChild) setNewData21b((prev) => ({ ...prev, isLoading: true }));
      else setNewData21((prev) => ({ ...prev, isLoading: true }));

      const [summaryRes, targetRes] = await Promise.all([
        fetch(`/api/dashboards/bi/${type}?contractType=1&contractType=3&${isChild ? "userId" : "roleId"}=${paramId}&summary=true`),
        fetch(`/api/accounts/yearlytargets`)
      ]);

      const summaryData = await summaryRes.json();
      const targetData = await targetRes.json();

      if (summaryData.statusCode === "200" && targetData.statusCode === "200") {
        const newData = summaryData?.data || {};
        const targetList = targetData?.data
          ? Object.entries(targetData.data).map(([id, item]) => ({
              id,
              targetValue: item,
            }))
          : [];

        const listData = Object.entries(newData).map(([id, userObj]) => {
          const [name, details] = Object.entries(userObj)[0];
          const targetItem = targetList.find((t) => String(t.id) === String(id));
          return {
            id,
            name,
            summary: {
              ...details.summary,
              yearlyTarget: targetItem?.targetValue || 0,
            },
          };
        });

        if (isChild) {
          setNewData21b({ data: listData, isLoading: false });
          dispatch(setSaleChildData(paramId, listData));
        } else {
          setNewData21({ data: listData, isLoading: false });
          dispatch(setSaleParentData(paramId, listData));
        }
      }
    } catch (error) {
      console.error("Error fetching EXD21 data:", error);
      if (isChild) setNewData21b((prev) => ({ ...prev, isLoading: false }));
      else setNewData21((prev) => ({ ...prev, isLoading: false }));
    }
  };


  useEffect(() => {
    if (!selectedUser && isSelectedChildUser) return;
    if (!isSelectedChildUser) {
      const cached = salePerformance?.parent[selectedUser?.value];
      if (cached) {
        setNewData21({ data: cached, isLoading: false });
      } else {
        fetchEXD21Data({ type: "21a", paramId: selectedUser?.value || "", isChild: false });
      }
    }
  }, [selectedUser, isSelectedChildUser]);


  useEffect(() => {
    if (!selectedChildUserId) return;
    if (isSelectedChildUser) {
      const cached = salePerformance?.child[selectedChildUserId];
      if (cached) {
        setNewData21b({ data: cached, isLoading: false });
      } else {
        fetchEXD21Data({ type: "21b", paramId: selectedChildUserId, isChild: true });
      }
    }
  }, [isSelectedChildUser, selectedChildUserId]);

  const handleSelectChildUser = (id) => {
    setSelectedChildUserId(id);
    setIsSelectedChildUser(true);
  };

  const handleBackToUser = () => {
    setIsSelectedChildUser(false);
  };
    
  return (
                   <Grid
        item
        xs={12}
        sm={6}
        md={3}
        lg={3}
    >
        <Paper
    elevation={1}
            sx={{
                p: 1,
                height: "100%",
                borderRadius: 2,
                position: "relative",
            }}
        >
            {
                (newData21.isLoading||newData21b.isLoading)?<Box  p={2}><MaintenanceItemEmpty/></Box>:
                <>
                     <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ mb: 2 }}
                    >
                        <Typography sx={{ fontWeight: 700, fontSize: 14 }}>
                            {props.translate("salesKPI")}
                        </Typography>
                                    {
                                !isSelectedChildUser? 
                        <Box width={130}>
                        <Select
                                options={usersOption}
                                value={selectedUser}
                                onChange={handleSelectedUser}
                            />
                        </Box>
                        :
                            
                                       <Button onClick={handleBackToUser} size="small">
                                                      {props.translate("Back")}
                                                    </Button>
                            }
                    </Box>
                              <Box px={"0.2rem"} pb={2} pt={1}>


                    <Scrollbar
                        disableTracksWidthCompensation
                        style={{ height: "450px" }}
                        scrollerProps={{
                            renderer: ({ elementRef, ...rest }) => (
                                <div {...rest} ref={elementRef} id="scrollableDiv" />
                            ),
                        }}
                    >
                        {
                            isSelectedChildUser?
                            <SalePerformanceTrackerChild
                             data={newData21b}
                              expandable={false}
                            handleSelectUser={handleSelectChildUser}
                             key={isSelectedChildUser}
                              isSelectedChildUser={isSelectedChildUser}
                              />:<SalePerformanceTrackerParent 
                              data={newData21}
                               expandable={false} 
                               handleSelectUser={handleSelectChildUser}
                                key={isSelectedChildUser} 
                                isSelectedChildUser={isSelectedChildUser}/>
                        }
                    </Scrollbar>
                              </Box>
                    <DashboardCardInfo title={"Comparison Of Current Year And Prior Year Sales And Targets"}/>
                </>
            }

        </Paper>
            </Grid>
  )
}
const SalePerformanceTrackerParent = ({
  data,
  colorClass = "light-yellow",
  expandable = false,
  handleSelectUser,
  isSelectedChildUser,
  isLoading
}) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleExpand = (idx) => {
    if (!expandable) return;
    setExpandedIndex((prev) => (prev === idx ? null : idx));
  };

  const displayData = data?.data || [];

  return (
    <ul className="md-bar-graphlist" style={{ margin: 0, padding: 0 }}>
      {Array.isArray(displayData) &&
        displayData.map((item, idx) => {
          const isExpanded = expandedIndex === idx;

          // Safe YoY calculation
          const currentYearSale = item.summary.currentYearSale || 0;
          const lastYearSale = item.summary.lastYearSale || 0;

          let diff = 0;
          let displayYoY = "N/A";
          let isGrowth = false;

          if (lastYearSale > 1) {
            diff = ((currentYearSale - lastYearSale) / lastYearSale) * 100;
            const safeDiff = Math.max(Math.min(diff, 999), -999); 
            displayYoY = `${Math.abs(safeDiff.toFixed(1))}%`;
            isGrowth = safeDiff >= 0;
          }
          const percentAchieved = (() => {
            const target = item.summary.yearlyTarget;
            const achieved = item.summary.currentYearSale;
            if (!target || target === 0) return 100;
            const percent = (achieved / target) * 100;
            return Math.min(Math.max(percent, 0), 100);
          })();

          return (
            <li
              key={idx}
              style={{
                cursor: expandable ? "pointer" : "default",
                padding: "8px 0",
              }}
              onClick={() => toggleExpand(idx)}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                className="row-label"
              >
                <em style={{ fontWeight: "500", fontSize: "1rem" }}>
                  {item?.userName || item?.name || ""}
                </em>
                {item?.summary?.currentYearSale && (
                  <strong
                    style={{ fontSize: "1rem", color: "#333" }}
                    title={
                      "Current Year Sale: " +
                      item.summary.currentYearSale.toLocaleString()
                    }
                  >
                    {nFormatter(item.summary.currentYearSale, 2)}
                  </strong>
                )}
              </Box>

              {Number.isFinite(percentAchieved) && (
                <Box mt={1}>
                  <Tooltip
                    title={`${percentAchieved.toFixed(1)}% Achieved`}
                    arrow
                  >
                    <Box>
                      <LinearProgress
                        style={{ height: 15, cursor: "pointer" }}
                        className={colorClass}
                        variant="determinate"
                        value={percentAchieved}
                      />
                    </Box>
                  </Tooltip>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    mt={0.5}
                    sx={{ fontSize: 12, color: "#666", fontWeight: 500 }}
                  >
                    <span></span>
                    <span
                      title={
                        "Current Year Target: " +
                        item.summary.yearlyTarget.toLocaleString()
                      }
                    >
                      {nFormatter(item.summary.yearlyTarget, 2)}
                    </span>
                  </Box>
                </Box>
              )}

              {/* Expanded Details */}
              {item?.summary && (
                <Box
                  mt={2}
                  sx={{
                    background: "#fafafa",
                    borderRadius: 8,
                    p: 2,
                    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={4}>
                      <strong style={{ color: "#555" }} title="Current Year To Date">
                        CYTD Sales
                      </strong>
                      <div
                        style={{ color: "#0a7", fontWeight: 500,paddingTop:"0.2rem" }}
                        title={currentYearSale.toLocaleString()}
                      >
                        {nFormatter(currentYearSale, 2)}
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <strong style={{ color: "#555" }} title="Last Year To Date">
                        Prior Year Sales
                      </strong>
                      <div
                        style={{ color: "#d33", fontWeight: 500,paddingTop:"0.2rem" }}
                        title={lastYearSale.toLocaleString()}
                      >
                        {nFormatter(lastYearSale, 2)}
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      title={nFormatter(currentYearSale - lastYearSale, 2)}
                    >
                      <strong style={{ color: "#555" }}>YoY</strong>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Typography
                          variant="subtitle1"
                          color={isGrowth ? "green" : "red"}
                          mr={0.5}
                          sx={{ fontWeight: "bold" }}
                        >
                          {displayYoY}
                        </Typography>
                        {displayYoY !== "N/A" && (
                          isGrowth ? (
                            <ArrowUpward style={{ color: "green", fontSize: 20 }} />
                          ) : (
                            <ArrowDownward style={{ color: "red", fontSize: 20 }} />
                          )
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <strong style={{ color: "#555" }} title="Current Year Sales">
                        CYTD Sales
                      </strong>
                      <div
                        style={{ color: "#d33", fontWeight: 500,paddingTop:"0.2rem" }}
                        title={currentYearSale.toLocaleString()}
                      >
                        {nFormatter(currentYearSale, 2)}
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <strong style={{ color: "#555" }} title="Current Year Target">
                        CY Target
                      </strong>
                      <div
                        style={{ color: "#d33", fontWeight: 500,paddingTop:"0.2rem" }}
                        title={item.summary.yearlyTarget.toLocaleString()}
                      >
                        {nFormatter(item.summary.yearlyTarget, 2)}
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <strong style={{ color: "#555" }}>Achieved</strong>
                      <div
                        style={{
                          color:
                            percentAchieved >= 100 ? "#2e7d32" : "#f57c00",
                          fontWeight: "bold",
                          paddingTop:"0.2rem"
                        }}
                      >
                        {percentAchieved.toFixed(1)}%
                      </div>
                    </Grid>
                     <Grid item xs={8}></Grid>
                    {!isSelectedChildUser && (
                <Grid item xs={4}>
  <p
    style={{
      color: "gray",
      textDecoration: "underline",
      cursor: "pointer",
    }}
    onClick={() => handleSelectUser(item.id)}
  >
    Details
  </p>
</Grid>

                    )}
                  </Grid>
                </Box>
              )}
            </li>
          );
        })}
    </ul>
  );
};


const SalePerformanceTrackerChild = ({ 
  data, 
  expandable = false,
}) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleExpand = (idx) => {
    if (!expandable) return;
    setExpandedIndex((prev) => (prev === idx ? null : idx));
  };

  const displayData = data?.data || [];

  return (
    <ul className="md-bar-graphlist" style={{ margin: 0, padding: 0 }}>
      {Array.isArray(displayData) &&
        displayData.map((item, idx) => {
          const isExpanded = expandedIndex === idx;

          // Safe YoY Calculation
          const currentYearSale = item.summary.currentYearSale || 0;
          const lastYearSale = item.summary.lastYearSale || 0;

          let diff = 0;
          let displayYoY = "N/A";
          let isGrowth = false;

          if (lastYearSale > 1) {
            diff = ((currentYearSale - lastYearSale) / lastYearSale) * 100;
            const safeDiff = Math.max(Math.min(diff, 999), -999);
            displayYoY = `${Math.abs(safeDiff.toFixed(1))}%`;
            isGrowth = safeDiff >= 0;
          }

          const percentAchieved = (() => {
            const target = item.summary.yearlyTarget;
            const achieved = item.summary.currentYearMaintenanceRevenue;
            if (!target || target === 0) return 100;
            const percent = (achieved / target) * 100;
            return Math.min(Math.max(percent, 0), 100); 
          })();

          return (
            <li
              key={idx}
              style={{
                cursor: expandable ? "pointer" : "default",
                padding: "8px 0",
              }}
              onClick={() => toggleExpand(idx)}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                className="row-label"
              >
                <p style={{ fontWeight: "500", fontSize: "1rem" }}>
                  {item?.userName || item?.name || ""}
                </p>
              </Box>

              {item?.summary && (
                <Box
                  mt={2}
                  sx={{
                    background: "#fafafa",
                    borderRadius: 8,
                    p: 2,
                    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={4}>
                      <strong style={{ color: "#555" }} title="Current Year To Date">CYTD Sales</strong>
                      <div style={{ color: "#0a7", fontWeight: 500,paddingTop:"0.2rem" }} title={currentYearSale.toLocaleString()}>
                        {nFormatter(currentYearSale, 2)}
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <strong style={{ color: "#555" }} title="Last Year To Date">Prior Sales</strong>
                      <div style={{ color: "#d33", fontWeight: 500,paddingTop:"0.2rem" }} title={lastYearSale.toLocaleString()}>
                        {nFormatter(lastYearSale, 2)}
                      </div>
                    </Grid>
                    <Grid item xs={4} title={nFormatter(currentYearSale - lastYearSale, 2)}>
                      <strong style={{ color: "#555" }}>YoY</strong>
                      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>
                        <Typography 
                          variant="subtitle1" 
                          color={isGrowth ? "green" : "red"} 
                          mr={0.5} 
                          sx={{ fontWeight: 'bold' }}
                        >
                          {displayYoY}
                        </Typography>
                        {displayYoY !== "N/A" && (
                          isGrowth ? 
                            <ArrowUpward style={{ color: 'green', fontSize: 20 }} /> :
                            <ArrowDownward style={{ color: 'red', fontSize: 20 }} />
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </li>
          );
        })}
    </ul>
  );
};
export default SalePerformanceTrackerWidgets